import React, { useState, useEffect } from 'react';
import api from '../services/api';

export default function Abastecimento() {
  const [abastecimentoList, setAbastecimentoList] = useState([]);
  const [frotaList, setFrotaList] = useState([]);

  const [placa, setPlaca] = useState('');
  const [odometro, setOdometro] = useState('');
  const [litros, setLitros] = useState('');
  const [total, setTotal] = useState('');
  const [posto, setPosto] = useState('');
  const [comprovanteNome, setComprovanteNome] = useState('');

  useEffect(() => {
    carregarDados();
  }, []);

  const carregarDados = async () => {
    try {
      const [resAbas, resFrota] = await Promise.all([
        api.get('/abastecimento'),
        api.get('/frota')
      ]);
      setAbastecimentoList(Array.isArray(resAbas.data) ? resAbas.data : []);
      setFrotaList(Array.isArray(resFrota.data) ? resFrota.data : []);
    } catch (err) {
      console.error("Erro ao carregar dados:", err);
    }
  };

  const handleFileUpload = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setComprovanteNome(file.name);
      };
      reader.readAsDataURL(file);
    }
  };

  const registrarAbastecimento = async (e) => {
    e.preventDefault();
    if (!placa) {
      alert('Selecione um veículo da frota.');
      return;
    }

    const dados = {
      id: Date.now().toString(),
      placa,
      odometro,
      litros,
      total: parseFloat(total) || 0,
      posto,
      comprovante: comprovanteNome || 'Sem comprovante'
    };

    try {
      await api.post('/abastecimento', dados);

      {
        setPlaca(''); setOdometro(''); setLitros(''); setTotal(''); setPosto(''); setComprovanteNome('');
        carregarDados();
        alert('Abastecimento registrado com auditoria e integrado ao Financeiro!');
      }
    } catch (err) {
      console.error("Erro:", err);
      alert('Erro de conexão.');
    }
  };

  const excluirAbastecimento = async (id) => {
    if (!window.confirm("Deseja realmente excluir este registro de abastecimento?")) return;
    try {
      await api.delete(`/abastecimento/${id}`);
      await carregarDados();
    } catch (err) {
      console.error("Erro:", err);
    }
  };

  return (
    <div style={{ padding: '20px', color: '#fff' }}>
      <h2 style={{ fontSize: '22px', fontWeight: 'bold', marginBottom: '20px' }}>Controle & Auditoria de Abastecimento (Antifraude)</h2>

      {/* Formulário de Cadastro */}
      <form onSubmit={registrarAbastecimento} style={{ backgroundColor: '#141414', border: '1px solid #2a2a2a', padding: '20px', borderRadius: '8px', marginBottom: '24px', display: 'grid', gridTemplateColumns: 'repeat(6, 1fr)', gap: '12px', alignItems: 'end' }}>
        <div>
          <label style={{ fontSize: '11px', color: '#a0a0a0', display: 'block', marginBottom: '4px' }}>VEÍCULOS (FROTA)</label>
          <select value={placa} onChange={e => setPlaca(e.target.value)} style={inputStyle} required>
            <option value="">Selecione a Placa</option>
            {frotaList.map(f => (
              <option key={f.id || f.placa} value={f.placa}>{f.placa} - {f.modelo}</option>
            ))}
          </select>
        </div>

        <div>
          <label style={{ fontSize: '11px', color: '#a0a0a0', display: 'block', marginBottom: '4px' }}>ODÔMETRO (KM)</label>
          <input type="text" placeholder="Ex: 54200" value={odometro} onChange={e => setOdometro(e.target.value)} style={inputStyle} required />
        </div>

        <div>
          <label style={{ fontSize: '11px', color: '#a0a0a0', display: 'block', marginBottom: '4px' }}>LITROS</label>
          <input type="text" placeholder="Ex: 150" value={litros} onChange={e => setLitros(e.target.value)} style={inputStyle} required />
        </div>

        <div>
          <label style={{ fontSize: '11px', color: '#a0a0a0', display: 'block', marginBottom: '4px' }}>VALOR TOTAL (R$)</label>
          <input type="number" step="0.01" placeholder="Ex: 950.00" value={total} onChange={e => setTotal(e.target.value)} style={inputStyle} required />
        </div>

        <div>
          <label style={{ fontSize: '11px', color: '#a0a0a0', display: 'block', marginBottom: '4px' }}>POSTO</label>
          <input type="text" placeholder="Nome do Posto" value={posto} onChange={e => setPosto(e.target.value)} style={inputStyle} required />
        </div>

        <div>
          <label style={{ fontSize: '11px', color: '#a0a0a0', display: 'block', marginBottom: '4px' }}>FOTO/PDF NOTINHA</label>
          <input type="file" accept="image/*,application/pdf" onChange={handleFileUpload} style={{ fontSize: '11px', color: '#aaa', padding: '6px', background: '#1a1a1a', border: '1px solid #333', borderRadius: '6px', width: '100%', boxSizing: 'border-box' }} />
        </div>

        <div style={{ gridColumn: 'span 6', marginTop: '6px' }}>
          <button type="submit" style={{ padding: '12px 24px', backgroundColor: '#007AFF', color: '#fff', border: 'none', borderRadius: '6px', fontWeight: 'bold', cursor: 'pointer', width: '100%' }}>
            💾 Salvar Abastecimento & Auditar Comprovante
          </button>
        </div>
      </form>

      {/* Tabela de Histórico */}
      <div style={{ backgroundColor: '#141414', border: '1px solid #2a2a2a', borderRadius: '8px', overflow: 'hidden' }}>
        <table style={{ width: '100%', borderCollapse: 'collapse', textAlign: 'left', fontSize: '14px' }}>
          <thead>
            <tr style={{ borderBottom: '1px solid #2a2a2a', color: '#a0a0a0', backgroundColor: '#1a1a1a' }}>
              <th style={{ padding: '14px' }}>Placa / Veículo</th>
              <th style={{ padding: '14px' }}>Odômetro</th>
              <th style={{ padding: '14px' }}>Litros</th>
              <th style={{ padding: '14px' }}>Valor Total</th>
              <th style={{ padding: '14px' }}>Posto</th>
              <th style={{ padding: '14px' }}>Comprovante (Notinha)</th>
              <th style={{ padding: '14px', textAlign: 'right' }}>Ações</th>
            </tr>
          </thead>
          <tbody>
            {abastecimentoList.length === 0 ? (
              <tr>
                <td colSpan="7" style={{ textAlign: 'center', padding: '30px', color: '#777' }}>Nenhum registro de abastecimento auditado.</td>
              </tr>
            ) : (
              abastecimentoList.map(item => (
                <tr key={item.id} style={{ borderBottom: '1px solid #222' }}>
                  <td style={{ padding: '14px', fontWeight: 'bold', color: '#007AFF' }}>{item.placa}</td>
                  <td style={{ padding: '14px' }}>{item.odometro} km</td>
                  <td style={{ padding: '14px' }}>{item.litros} L</td>
                  <td style={{ padding: '14px', color: '#FF3B30', fontWeight: 'bold' }}>R$ {Number(item.total || 0).toLocaleString('pt-BR', { minimumFractionDigits: 2 })}</td>
                  <td style={{ padding: '14px' }}>{item.posto}</td>
                  <td style={{ padding: '14px' }}>
                    {item.comprovante && item.comprovante !== 'Sem comprovante' ? (
                      <span style={{ color: '#32D74B', fontSize: '12px', fontWeight: 'bold' }}>📎 {item.comprovante}</span>
                    ) : (
                      <span style={{ color: '#888', fontSize: '12px' }}>Pendente</span>
                    )}
                  </td>
                  <td style={{ padding: '14px', textAlign: 'right' }}>
                    <button onClick={() => excluirAbastecimento(item.id)} style={{ padding: '6px 12px', backgroundColor: '#FF3B30', color: '#fff', border: 'none', borderRadius: '4px', cursor: 'pointer', fontSize: '12px' }}>Excluir</button>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}

const inputStyle = { width: '100%', padding: '10px', backgroundColor: '#1a1a1a', border: '1px solid #333', borderRadius: '6px', color: '#fff', boxSizing: 'border-box' };